import React, { useEffect, useState } from 'react';
import {
  PACIENTE_CONTACTO_CLAVES,
  pacientePlanillaSecciones,
  valoresDesdePaciente,
} from '../../constants/pacientePlanilla';
import { getChildAgeLabel } from '../../services/profileService';
import { sanitizePersonNameInput } from '../../utils/personName';
import '../../styles/profile.css';

const valorLista = (valor) => {
  if (Array.isArray(valor)) {
    return valor;
  }

  if (valor === undefined || valor === null || valor === '') {
    return [];
  }

  return [valor];
};

const PacientePlanillaForm = ({
  paciente,
  valores,
  planilla,
  onChange,
  modo = 'editar',
  ocultarContacto = false,
}) => {
  const esLectura = modo === 'lectura';
  const [activa, setActiva] = useState('identificacion');

  const mapaValores =
    valores && typeof valores === 'object'
      ? valores
      : paciente
        ? valoresDesdePaciente(paciente)
        : {};

  const seccionesFuente =
    esLectura && planilla && Array.isArray(planilla.secciones) && planilla.secciones.length > 0
      ? planilla.secciones
      : pacientePlanillaSecciones().map((seccion) => ({
          ...seccion,
          campos: seccion.campos
            .filter((campo) => !ocultarContacto || PACIENTE_CONTACTO_CLAVES.indexOf(campo.clave) === -1)
            .map((campo) => {
              const valor =
                mapaValores[campo.clave] !== undefined && mapaValores[campo.clave] !== null
                  ? mapaValores[campo.clave]
                  : '';

              return { ...campo, valor };
            }),
        }));

  const secciones = ocultarContacto
    ? seccionesFuente.map((seccion) => ({
        ...seccion,
        campos: (seccion.campos || []).filter(
          (campo) => PACIENTE_CONTACTO_CLAVES.indexOf(campo.clave) === -1
        ),
      }))
    : seccionesFuente;

  useEffect(() => {
    if (secciones.length === 0) {
      return;
    }

    if (!secciones.some((item) => item.id === activa)) {
      setActiva(secciones[0].id);
    }
  }, [activa, secciones]);

  const seccion = secciones.find((item) => item.id === activa) || secciones[0];

  const emitir = (clave, valor) => {
    if (!onChange) {
      return;
    }

    const siguiente = { ...mapaValores, [clave]: valor };

    if (clave === 'nombre') {
      siguiente.nombre = sanitizePersonNameInput(valor);
    }

    onChange(siguiente);
  };

  const dibujarCampo = (campo, indice) => {
    const clave = campo.clave;
    const valor =
      !esLectura && clave === 'edad'
        ? getChildAgeLabel(mapaValores.fecha_nacimiento)
        : campo.valor;
    const ancho = campo.ancho === 'wide' || campo.ancho === true;
    const visible = campo.valor_visible !== undefined && campo.valor_visible !== null
      ? campo.valor_visible
      : Array.isArray(valor)
        ? valor.join(', ')
        : valor;

    if (esLectura) {
      return (
        <div
          key={(clave || campo.etiqueta) + '-' + indice}
          className={'paciente-planilla-field' + (ancho ? ' paciente-planilla-field--wide' : '')}
        >
          <span>{campo.etiqueta}</span>
          {campo.tipo === 'foto' && visible ? (
            <img className="paciente-planilla-photo" src={visible} alt={campo.etiqueta} />
          ) : (
            <p>{visible === '' || visible === false || visible == null ? '—' : String(visible)}</p>
          )}
        </div>
      );
    }

    return (
      <div
        key={(clave || campo.etiqueta) + '-' + indice}
        className={'paciente-planilla-field' + (ancho ? ' paciente-planilla-field--wide' : '')}
      >
        <span>{campo.etiqueta}</span>
        {campo.tipo === 'textarea' ? (
          <textarea
            className="profile-ficha-input"
            rows={4}
            value={valor || ''}
            onChange={(event) => emitir(clave, event.target.value)}
          />
        ) : null}
        {campo.tipo === 'date' ? (
          <input
            className="profile-ficha-input"
            type="date"
            value={valor || ''}
            onChange={(event) => emitir(clave, event.target.value)}
          />
        ) : null}
        {campo.tipo === 'edad' ? (
          <input className="profile-ficha-input" type="text" value={valor || ''} readOnly />
        ) : null}
        {campo.tipo === 'select' ? (
          <select
            className="profile-ficha-input"
            value={valor || ''}
            onChange={(event) => emitir(clave, event.target.value)}
          >
            <option value="">Selecciona</option>
            {(campo.opciones || []).map((opcion) => (
              <option key={opcion.id} value={opcion.id}>
                {opcion.label}
              </option>
            ))}
          </select>
        ) : null}
        {campo.tipo === 'radio' ? (
          <div className="paciente-planilla-options">
            {(campo.opciones || []).map((opcion) => (
              <label key={opcion.id} className="paciente-planilla-option">
                <input
                  type="radio"
                  name={'planilla-' + clave}
                  checked={valor === opcion.id}
                  onChange={() => emitir(clave, opcion.id)}
                />
                {opcion.label}
              </label>
            ))}
          </div>
        ) : null}
        {campo.tipo === 'checkboxes' ? (
          <div className="paciente-planilla-options paciente-planilla-options--wrap">
            {(campo.opciones || []).map((opcion) => {
              const lista = valorLista(valor);
              const marcado = lista.indexOf(opcion.id) !== -1;

              return (
                <label key={opcion.id} className="paciente-planilla-option">
                  <input
                    type="checkbox"
                    checked={marcado}
                    onChange={() => {
                      const siguiente = marcado
                        ? lista.filter((item) => item !== opcion.id)
                        : lista.concat(opcion.id);
                      emitir(clave, siguiente);
                    }}
                  />
                  {opcion.label}
                </label>
              );
            })}
          </div>
        ) : null}
        {campo.tipo === 'foto' ? (
          <div className="paciente-planilla-foto-box">
            {valor ? <img className="paciente-planilla-photo" src={valor} alt={campo.etiqueta} /> : null}
            <input
              type="file"
              accept="image/jpeg,image/png,image/webp,image/gif"
              onChange={(event) => {
                const archivo = event.target.files && event.target.files[0];

                if (!archivo) {
                  return;
                }

                const reader = new FileReader();
                reader.onload = () => {
                  emitir(clave, typeof reader.result === 'string' ? reader.result : '');
                };
                reader.readAsDataURL(archivo);
              }}
            />
          </div>
        ) : null}
        {campo.tipo === 'texto' || !campo.tipo ? (
          <input
            className="profile-ficha-input"
            type="text"
            value={valor || ''}
            onChange={(event) => emitir(clave, event.target.value)}
          />
        ) : null}
      </div>
    );
  };

  if (!seccion) {
    return null;
  }

  return (
    <div className="paciente-planilla">
      <div className="paciente-planilla-tabs" role="tablist">
        {secciones.map((item, index) => (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={seccion.id === item.id}
            className={
              'paciente-planilla-tab' + (seccion.id === item.id ? ' paciente-planilla-tab--active' : '')
            }
            onClick={() => setActiva(item.id)}
          >
            {index + 1}. {item.titulo}
          </button>
        ))}
      </div>
      <div className="paciente-planilla-body" role="tabpanel">
        <div className="paciente-planilla-grid">
          {(seccion.campos || []).map((campo, indice) => dibujarCampo(campo, indice))}
        </div>
      </div>
    </div>
  );
};

export default PacientePlanillaForm;
